import { VueConstructor } from 'vue'
import routes from './router/routes'
import configRoutes from './router/config'
import forEach from 'lodash/forEach'
import lang from './lang'
import KwixeoTicketsStore from './store/modules/KwixeoTicketsStore'
import teamListeners from './broadcasts/team'

const KwixeoTickets = {
  install: function (Vue: VueConstructor, options: KwixeoTickets.PluginOptions): void {
    // Install lang
    this.installLang(options)

    Vue.prototype.$kwTickets = options

    // Install VueX
    this.installVueX(options)

    // Install routes
    this.installRoutes(options)

    require('./fontawesome')

    // Initialize broadcasts
    this.installBroadcasts(Vue, options)
  },

  installVueX: (options: KwixeoTickets.PluginOptions): void => {
    const store = options.store

    // Register VueX modules
    const modules = {
      tickets: KwixeoTicketsStore
    }
    forEach(modules, (module, key) => {
      if (!store.hasModule(key)) {
        store.registerModule(key, module)
      }
    })
  },

  installRoutes: (options: KwixeoTickets.PluginOptions): void => {
    const router = options.router
    const i18n = options.i18n

    routes(i18n).forEach(route => {
      router.addRoute(route)
    })

    configRoutes(i18n).forEach(route => {
      router.addRoute('configuration', route)
    })
  },

  installLang: (options: KwixeoTickets.PluginOptions): void => {
    const i18n = options.i18n

    forEach(lang, (messages, locale) => {
      i18n.mergeLocaleMessage(locale, messages)
    })
  },

  installBroadcasts (Vue: VueConstructor, options: KwixeoTickets.PluginOptions): void {
    const broadcast = Vue.prototype.$broadcast
    if (!broadcast) {
      return
    }

    broadcast.registerListeners('team', teamListeners(options.store))
  }
}

export default KwixeoTickets
